const btnTreeNode = {
  text: 'Cut',
  cancel: 'Cancel'
};

export default btnTreeNode;
